<template>
  <div class="text-xs-center pt-3">
    <span class="order-text-pagename elevation-2">On process</span>
    <transition name="slide-x-reverse-transition" mode="out-in">
      <orderListTable
        :fetching_order="isLoading"
        :orderList="orderList"
      ></orderListTable>
    </transition>
  </div>
</template>

<script>
import orderListTable from "@/components/back-office/DineIn/Order/OrderTable.vue";
import { mapActions, mapState } from "vuex";

export default {
  computed: {},
  components: {
    orderListTable,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      orderList: (state) => state.fetchDineIn.orderListOnProcess,
    }),
  },
  methods: {
    ...mapActions({ fetchOrderList: "fetchDineIn/fetchOrderList" }),
    async fetchData() {
      this.isLoading = true;
      await this.fetchOrderList({
        order_status: [1, 2],
      });
      this.isLoading = false;
      return;
    },
  },
  mounted() {
    this.fetchData();
    const path = [
      {
        text: "On process list",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped></style>
